/**
 * 무한 목록의 꼬리 — **한 벌을 모든 목록이 쓴다** (지원사업·관심 공고·커뮤니티·아티클).
 * 다음 쪽을 불러오는 동안 「불러오는 중…」, 더 없으면 「더 이상 없습니다.」.
 * 끝 표시가 없으면 독자는 목록이 멈춘 건지 끝난 건지 모른다.
 */
export function ListTail({ fetching, done }: { fetching: boolean; done: boolean }) {
  if (fetching) return <p className="py-6 text-center text-sm text-gray-400">불러오는 중…</p>;
  if (done) return <p className="py-6 text-center text-sm text-gray-400">더 이상 없습니다.</p>;
  return null;
}
